import React from 'react'

const Copyright = () => (
  <div
    css={{
      color: '#999',
      fontSize: '.8em',
      padding: '20px 20px 40px',

      '@media (min-width: 700px)': {
        paddingTop: 0,
      }
    }}
  >
    Copyright &copy; {(new Date()).getFullYear()} Patrícia Marques. All rights reserved. Some of the images may be property of third parties.
  </div>
)

export default Copyright



// WEBPACK FOOTER //
// ./src/components/Copyright.js